import React from 'react';

export class ErrorBoundary extends React.PureComponent {
	constructor (props) {
		super(props);
		this.state = {
			hasError: false,
		};
	}
	static fatalErrors = [
		'no slide navigate to'
	];
	static getDerivedStateFromError (error) {
		return { hasError: error instanceof Error || ErrorBoundary.fatalErrors.includes(error.message) };
	}

	isFatal(error) {
		return error instanceof Error;
		// return error instanceof Error &&    ErrorBoundary.fatalErrors.includes(error.message);
	}
	componentDidCatch (error, _errorInfo) {
		console.error(error);
		if (this.isFatal(error)) {
			this.props.onFatalError(error);
			this.setState({hasError: true});
		}
	}

	render () {
		if (this.state.hasError) {
			return null;
		}

		return this.props.children;
	}
}
